import React from 'react';

import { Grid } from '@mui/material';
import { AlineLogo } from 'src/components/icons/AlineLogo';
import { useGetCurrentDoc } from 'src/hooks';
import { makeStyles } from 'tss-react/mui';

import { PublicActionButtons, PublicAppBarTitle } from './components';

const useStyles = makeStyles()(theme => ({
  appBar: {
    backgroundColor: theme.appColors.primary,
    color: theme.palette.common.white,
    padding: theme.spacing(1.25, 3),
  },
}));

export function PublicAppBar(): JSX.Element | null {
  const { classes } = useStyles();
  const { document } = useGetCurrentDoc();
  if (!document) return null;

  return (
    <Grid
      container
      className={classes.appBar}
      sx={{
        alignItems: 'center',
        flexDirection: 'row',
        justifyContent: 'space-between',
      }}
    >
      <AlineLogo variant="white" />
      <PublicAppBarTitle title={document.name} />
      <PublicActionButtons document={document} />
    </Grid>
  );
}
